import { styled } from '@mui/material'
import { FC, memo } from 'react'

import { Flex } from '../../../styles'
import { SpotOrderbook } from '../OrderList/Orderbook'

const Wrap = styled(Flex)`
  width: 100%;
`

export const MobileOrderBook = memo(() => {
  return (
    <Wrap>
      <SpotOrderbook />
    </Wrap>
  )
})
